import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import AppWrapper from '@/app/App';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/app/i18n'; // Adjust the path according to where your i18n configuration file is located
import { BrowserRouter as Router } from 'react-router';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Enable StrictMode in development only.
const AppContent = (
    <Router>
        <AuthProvider>
            <ThemeProvider>
                <I18nextProvider i18n={i18n}>
                    <AppWrapper />
                </I18nextProvider>
            </ThemeProvider>
        </AuthProvider>
    </Router>
);

root.render(import.meta.env.DEV ? <React.StrictMode>{AppContent}</React.StrictMode> : AppContent);
